import { render, staticRenderFns } from "./info.vue?vue&type=template&id=9add8e0c&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9add8e0c')) {
      api.createRecord('9add8e0c', component.options)
    } else {
      api.reload('9add8e0c', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=9add8e0c&", function () {
      api.rerender('9add8e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/patch-production-order/info.vue"
export default component.exports